module.exports = __webpack_public_path__ + "img/shuixi04.9a990119.png";